import { Component, Input, OnInit } from '@angular/core';
import { UpdateUser, UpdateUserDefaultValues } from '../update-user';
import { TranslationService } from 'src/app/services/translation.service';

@Component({
    selector: 'app-edit-profile-form',
    templateUrl: './edit-profile-form.component.html',
    styleUrls: ['./edit-profile-form.component.scss'],
    standalone: false
})
export class EditProfileFormComponent implements OnInit {
  @Input() updateUser: UpdateUser = UpdateUserDefaultValues();
  translations: any;

  constructor(private translationService: TranslationService) {}

  ngOnInit(): void {
    this.translationService.getTranslation().subscribe({
      next: (translations) => {
        this.translations = translations;
      }
    });
  }
}
